/* Luvia — Mobile Sticky ATC Enhancements */
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 7500; // 单位：美分

  // 款式名称映射（后台值 → 显示名）
  var VARIANT_NAME_MAP = {
    '1.0ct-Classic Minimalist (Smooth Band)': 'Classic Minimalist',
    '1.0ct-Luxury Pave': 'Pavé Accent',
    'Classic Minimalist (Smooth Band)': 'Classic Minimalist',
    'Luxury Pave': 'Pavé Accent'
  };

  function formatCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getShortVariantName(raw) {
    if (!raw) return '';
    for (var key in VARIANT_NAME_MAP) {
      if (raw.indexOf(key) !== -1) return VARIANT_NAME_MAP[key];
    }
    // 截断后台 SKU 格式（含 - 和括号）
    var cleaned = raw.replace(/\d+\.\d+ct-/g, '').replace(/\s*\(.*?\)/g, '').trim();
    return cleaned;
  }

  function getPriceCents() {
    // 从页面 variant 数据读取当前价格（美分）
    var priceEl = document.querySelector('.price .price__regular .price-item--regular, .price__regular .price-item, [data-essential-cart-element="price"]');
    if (!priceEl) return null;
    var text = priceEl.textContent.replace(/[^0-9.]/g, '');
    var dollars = parseFloat(text);
    if (isNaN(dollars)) return null;
    return Math.round(dollars * 100);
  }

  function updateShippingBadge() {
    if (window.innerWidth > 749) return;
    var badge = document.getElementById('luvia-shipping-badge');
    if (!badge) return;
  badge.textContent = 'Buy 2, second piece 30% off';
  badge.style.color = '#6B6560';
  }

  function updateVariantLabel() {
    if (window.innerWidth > 749) return;
    var label = document.getElementById('luvia-variant-label');
    if (!label) return;

    // 读取当前选中的 variant 文字
    var variantEl = document.querySelector('[data-essential-cart-element="variant-select"] select, [data-essential-cart-element="variant-select"] .selected');
    var raw = '';
    if (variantEl) {
      raw = variantEl.tagName === 'SELECT'
        ? (variantEl.options[variantEl.selectedIndex] ? variantEl.options[variantEl.selectedIndex].text : '')
        : variantEl.textContent;
    }
    label.textContent = getShortVariantName(raw) || label.textContent;
  }

  function injectStickyUI() {
    if (window.innerWidth > 749) return;

    var container = document.querySelector('[data-essential-cart-element="container-mobile"]');
    if (!container) return;

    // 注入免邮 badge（如果还没有）
    if (!document.getElementById('luvia-shipping-badge')) {
      var badge = document.createElement('div');
      badge.id = 'luvia-shipping-badge';
      badge.style.cssText = [
        'font-size:11px',
        'text-align:center',
        'padding:3px 12px 0',
        'line-height:1.4'
      ].join(';');
      container.appendChild(badge);
    }

    // 注入款式标签（如果还没有）
    if (!document.getElementById('luvia-variant-label')) {
      var label = document.createElement('div');
      label.id = 'luvia-variant-label';
      label.style.cssText = [
        'font-size:13px',
        'color:#252321',
        'padding:6px 12px 0',
        'font-weight:500'
      ].join(';');
      container.insertBefore(label, container.firstChild);
    }

    updateShippingBadge();
    updateVariantLabel();
  }

  // 隐藏只有一个值的 variant 选项组
  function hideSingleValueOptions() {
    var pickers = document.querySelectorAll('.product-form__input');
    pickers.forEach(function (picker) {
      var inputs = picker.querySelectorAll('input[type="radio"]');
      if (inputs.length <= 1) {
        picker.classList.add('product-form__input--single-value');
      }
    });
  }

  // 给页面底部加 padding 防止 sticky bar 遮挡
  function addBodyPadding() {
    if (window.innerWidth > 749) return;
    var bar = document.querySelector('[data-essential-cart-element="container-mobile"]');
    if (!bar) return;
    var h = bar.offsetHeight || 120;
    var main = document.querySelector('main, #MainContent');
    if (main) main.style.paddingBottom = h + 'px';
  }

  function init() {
    hideSingleValueOptions();
    injectStickyUI();

    // 监听 variant 变化
    document.addEventListener('variant:changed', function () {
      setTimeout(function () {
        updateShippingBadge();
        updateVariantLabel();
      }, 100);
    });

    // 监听 Essential Cart 的 variant select 变化
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest('[data-essential-cart-element="variant-select"]')) {
        setTimeout(updateVariantLabel, 50);
      }
    });

    // setTimeout(addBodyPadding, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 延迟再跑一次，等 Essential Cart 渲染完
  setTimeout(function () {
    injectStickyUI();
    // addBodyPadding();
  }, 2000);

})();
